import { memberApi } from '../member';

/** IM media uploads — always return objectKey; never bucket URL. */
export const uploadApi = {
  image: (file) => memberApi.uploadOssImImage(file),
  gif: (file) => memberApi.uploadOssImGif(file),
  audio: (file) => memberApi.uploadOssImAudio(file),
  video: (file) => memberApi.uploadOssImVideo(file),
  file: (file) => memberApi.uploadOssImFile(file),
};
